<template>
  <div>
    <div class="col-md-12">
      <customer-documents :customer="customer" :relations="relations"></customer-documents>
    </div>
    <div class="col-md-6">
      <customer-services :customer="customer" :source="sources.find(source => source.id === 'devis-b2b')"></customer-services>
    </div>
    <div class="col-md-6">
      <customer-services :customer="customer" :source="sources.find(source => source.id === 'communication')"></customer-services>
    </div>
  </div>
</template>

<script>
  import SourceApp from '@db2b/keystone/components/Entities/SourceApp.vue'
  import CustomerServices from './ServiceAndDocuments/CustomerServices.vue'
  import CustomerDocuments from './ServiceAndDocuments/CustomerDocuments.vue'
  import moment from 'moment'

  export default {
    components: {CustomerServices, CustomerDocuments},
    name: 'services-and-documents',
    props: ['customer', 'relations'],
    computed: {
      sources () {
        return this.$model.source_app.get()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// ServiceAndDocuments.vue?7caff380